import { Howl, Howler } from 'howler'
import store from '@/store/store'

const Sounds = {}
let elements = {}
let loaded = false

Sounds.init = async () => {
	Howler.volume(1)

	loaded = true
	let time = Date.now()
	const files = require.context('@/assets/sounds/', true, /^.*\.mp3$/).keys()
	for (let id in files) {
		let slug = files[id].substr(2).replace('.mp3', '')
		
		let loop = false
		if (slug.indexOf('loop') > -1) loop = true

		let volume = 0.5
		if (slug === 'impact') volume = 0.9
		else if (slug === 'game-lose') volume = 1
		else if (slug === 'victory') volume = 0.75
		else if (slug === 'music-loop') volume = 0.1

		elements[slug] = new Howl({
			src: [ require('@/assets/sounds/' + files[id].substr(2)) ],
			volume,
			loop
		})
	}
	console.info(files.length + ' sounds loaded in ' + (Date.now() - time) + 'ms')
}

Sounds.play = (slug) => {
	if (store.getters.app.config.audio) {
		if (!loaded) Sounds.init()
		elements[slug].play()
	}
}

export default Sounds